module.exports = __webpack_public_path__ + "static/0-dd7c4321e6e85c76f219a3aa8ce4b326.png";